.appBar {
  position: absolute;
  top: var(--app-dev-banner-h, 0);
  left: 0;
  right: 0;
  z-index: 1100;
}

:global(:root[data-dev='true']) {
  --app-dev-banner-h: 24px;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  background-color: var(--tuna-palette-layers);
  z-index: 1;
  color: var(--tuna-palette-text-secondary);
  height: 48px;
  gap: 8px;
  align-items: center;
  padding: 0 8px;
  overflow: hidden;
}

.backButton {
  display: flex;
  align-items: center;
  padding-left: 0;
  padding-right: 0;
  min-width: 32px;
  flex-shrink: 0;
}

.placeholder {
  width: 32px;
  flex-shrink: 0;
}

.breadcrumbs {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}
